<template>
    <div class="container">
        <p class="content">{{ companyName }}（简称“我们”）针对“{{ appName }}”APP（简称“本应用”），依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》
            （GB/T 35273-2017）以及其他相关法律法规和技术规范制定《个人信息保护政策》（简称“隐私政策”）。
        </p>

        <p class="contentBlack">
            为了更好的保护您的个人信息，特别提醒您认真阅读并充分理解本《用户协议》（以下简称“本协议”），
            确保您充分理解本协议中各条款。请您务必谨慎审阅、充分理解各条款内容，特别是免除或者限制责任的条款
            （该等条款通常含有“不负任何责任”、“无义务”等词汇），
            和其他限制用户权利的条款（该等条款通常含有“不得”等词汇），
            限制、免责条款可能以加粗形式提示您注意。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。
            若您在平台消费、使用服务、注册账号、登录账号，均视为对本协议的接受，并同意接受各项条款的约束。
            如您对本协议内容有任何疑问、意见或建议，您可以通过“{{ appName }}”客户端内的“帮助与咨询”页面与我们联系。
        </p>

        <p class="content">《个人信息保护政策》目录</p>
        <p class="content">一、引言</p>
        <p class="content">二、我们如何收集和使用您的个人信息</p>
        <p class="content">三、我们如何使用Cookie和同类技术</p>
        <p class="content">四、我们如何共享、转让、公开披露您的个人信息</p>
        <p class="content">五、我们如何保护您的个人信息</p>

        <p class="content">六、您的权利</p>
        <p class="content">七、我们如何存储您的个人信息</p>
        <!-- <p class="content">八、我们如何处理儿童的个人信息</p> -->
        <p class="content">八、使用须知</p>
        <p class="content">九、联系我们</p>
        <p class="content">十、本政策如何更新</p>
        <p class="content">十一、争议解决</p>

        <p class="contentBlack">一、引言</p>
        <p class="content">1.1 平台的各项电子服务的所有权和运作权归平台所有者所有。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</p>
        <p class="contentBlack">1.2 用户确认：自身已年满18周岁，并拥有完全民事行为能力。</p>
        <p class="contentBlack">1.3 用户点击同意本协议的，即视为用户确认自己具有享受平台服务、下单充值购物等相应的权利能力和行为能力，能够独立承担法律责任。</p>
        <p class="contentBlack">1.4 平台保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容的权利。</p>


        <p class="contentBlack">二、我们如何收集和使用您的个人信息</p>
        <p class="content">2.1 我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目
            的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保 护措施来保护您的个人信息。
            如果我们欲将您的个人信息用于本隐私政策未载明的其它用途，或基于特定目的将收集而来的信息用于其他目的，我们会及时以合理的 方式向您告知，并在使用前再次征得您的同意。</p>
        <p class="contentBlack">2.2 个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本隐私政策中涉及的个人信息
            包括：基本信息（包括个人姓名、生日、性别、个人电话号码）；个人身份信息（包括身份证、户口本）；生物识别特征（静态或动态的面部特征）；网络身份标识 信息（包括账号、IP地址及与前述有关的密码）；个人上网记录（
            包括网站浏览记录、软件使用记录、点击记录）；个人常用设备信息（包括设备名称、设备型 号、操作系统和应用程序版本、设备设置、设备MAC地址、唯一设备标识符、设备环境、应用信息列表等软硬件特征信息）；个人位置信息
            （包括精准定位信息、 经纬度以及WLAN接入点等传感器信息等）； 个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，本隐私政策中涉及的个
            人敏感信息包括：您的生物识别特征（静态或动态的面部特征）；个人身份信息（包括身份证、驾驶证、户口本）；网络身份识别信息（包括账户名、账户昵称、及 与前述有关的密码与密码保护问题和答案）；其他信息
            （包括手机号码、网页浏览记录、精准定位信息）。</p>
        <p class="content">2.3 通常情况下，我们会会出于以下目的收集和使用您的个人信息：</p>
        <p class="content">2.3.1【注册】当您注册本平台账号时，我们会收集您的昵称、性别、出生年月日、工作地区、身高、学历、月收入区间、手机号码，收集这些信息是为了帮助您完成本平台注册，建立您的个人信息。
            手机号码属于个人敏感信息，收集此类信息是为了满足相关法律法规的网络实名制要求，若您不提供这类信息，您可能无法正常使用我们的服务。在使用服务过程中，如果您提供以下额外信息补全个人资料，
            将有助于我们给您提供更好的服务和体验：您的籍贯、家乡、职业、学校、您本人的真实头像等。但如果 您不提供这些信息，将不会影响使用我们产品或服务的基本功能。您提供的上述信息将在您使用本服务期间持续授权我们使用。
            当您注册或者找回密码时您需要相应 开启短信自动读取短信的权限，如果您拒绝/取消提供，您将无法使用短信自动读取功能，同时，您也可以随时通过您设备的相关功能设置开启/取消该权限。</p>

        <p class="content">为了保障平台和运营安全，我们会申请系统权限手机手机号码、IMEI、IMSI、本机应用安装列表、MAC地址等设备信息用于平台安全风控。</p>
        <p class="contentBlack">特别的，在您同意我们的隐私政策之后，我们可能会在不影响您使用的时间内（例如App切换至后台时），将设备的IMEI、IMSI、MAC 地址等设备信息传输至服务器，此时可能会造成
            我们在应用处于后台的时候获取用户的MAC 等信息的行为，希望您能理解。</p>

        <p class="content">2.3.2【信息发布及分享】当您上传头像、使用动态及其他信息发布功能公开发布信息，包括发布图片、短视频时，您需要相应开启摄像头、相册、存储权限。同时，您也可以随时通过您设备的相关功能设置开启/取消该权限。
            当您取消该授权后，我们无法再为您提供上述与之对应的服务。您上传的动态照片、短视频、评论、点赞等信息会存储在我们的服务器中，因为存储是实现这一功能所必需的。我们会以加密的方式存储，您也可以随时删除这些信息。
            除非经您自主选择或遵从相关法律法规要求，我们不会对外提供上述动态信息，或者将其用于该功能以外的其他用途。您在使用我们的产品/服务（譬如动态、情侣空间等）分享信息至其他平台时，你需要相应开启获取应用账户权限，
            如您拒绝开启，您将无法使用信息分享功能。</p>

        <p class="content">特别提示：您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发布动态时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。</p>
        <p class="content">2.3.3【语音聊天】当您使用语音聊天相关服务时（例如：蜜语、消息里发送语音内容），您需要相应开启麦克风、存储权限来进行语音交互。开启手机存储权限是实现这一功能所必需的。同时，
            您也可以随时通过您设备的相关功能设置开启/取消该权限。当您取消该授权后，我们将无法再为您提供上述与之对应的服务。</p>
        <p class="content">2.3.4【位置】当您进行账号注册、查看附近的人、附近动态，消息界面查看您与对方的距离时，我们会在获得您的自主选择同意开启位置权限后，记录您的地理位置信息。该信息属于个人敏感信息，
            拒绝提供该信息会使您无法使用上述功能，但不影响您正常使用本平台的其他功能。此外，您可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="content">2.3.5【支付】当您在本平台上开通会员服务、购买礼物、购买平台货币等发生支付行为时，需要使用到支付功能。在支付过程中， 我们可能会收集您的第三方支付渠道的user ID 
            (例如支付宝user ID、微信open ID、QQ钱包open ID或银行卡信息)（个人敏感信息）。上述信息为我们向您提供您购买商品和/或服务所必须的信息，我们无法仅根据该信息获得您的个人财产信息，也不能识别特定自然人身份信息。</p>
        <p class="content">2.3.6【认证】当您使用实名认证、人脸认证、学历认证、信用认证、开通居民身份证网上功能凭证（简称“网证”）时，我们将会收集您的手机号码、姓名、身份证号码、学历信息、职业信息，
            上述信息属于个人敏感信息，如您拒绝提供上述信息，您可能无法完成上述认证，但不影响您正常使用本平台的其他功能，您也可以通过注销账户功能随时自助删除个人认证信息或者通过联系人
            工客服协助处理删除个人认证信息。</p>

        <p class="content">2.3.7 【第三方获取】若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感
            信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法 律责任；同时，我们的专业安全团队对个人信息会进行安全防护
            （包括敏感信息分级分类、敏感信息使用的访问控制、敏感信息加密存储等）。我们会使用不低于我 们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。</p>
        <p class="content">
            2.3.8【提供优质服务】为了保证向您提供及时、优质的服务，您同意我们向您提供的电话、手机、电子邮箱拨打电话或发送短信及邮件
            （内容包括但不限于服务流程确认，告知您平台活动信息和资讯、新服务或新产品的推介等，提示再次登录本网站等），
            您同意开启麦克风权限来与我们进行电话、手机沟通。
        </p>
        <p class="content">2.3.9【客服支持】当您向本平台发起投诉、申诉或进行咨询时，为了您的账号与系统安全，我们可能需要您先行提供账号信息，并与您之前的个人信息相匹配以验证您的用户身份。同时，
            为了方便与您联系或帮助您解决问题，我们可能还需要您提供姓名、手机号码、电子邮件及其他联系方式等个人信息（个人敏感信息）。另 外，我们还会收集您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、
            与您的需求相关联的其他必要信息。我们收集这些信息是为了调查事实与帮助 您解决问题，如您拒绝提供上述信息，我们可能无法向您及时反馈投诉、申诉或咨询结果。在进行投诉、申诉或进行咨询时，您可能需要相应的开启相册、
            相机、麦 克风、拨打电话权限来与客服沟通并提供相应材料。当然，您也可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="content">2.3.10【安全支持】为提高您使用我们产品/服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，
            更准确地识别违反法律法规或本平台相关协议规则的情况，我们可能使用或整合您的用户信息、交易信息、设备信息、有关网络日志以及我们合作伙伴取得您授权或依据法律共享给我们的信息，来综合判断您账户及交易风险、进行身份验证、
            检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。这些信息包括：</p>
        <p class="content">
            设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备型号、操作系统版本、设备识别码（包括IMEI/Android ID/Device_ID/IDFV/OAID/SN ID/MEID、SIM卡手机号、IMSI）、设备硬件序列号、
            Android id、网络设备硬件地址、MAC等软硬件特征信息、设备应用安装列表(GET_TASK检索应用程序)、设备所在位置相关信息（如IP 地址、WLAN接入点、蓝牙、基站、地理位置信息）。需要您注意，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息；
        </p>
        <p class="content">
            日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们产品或服务的详细使用情况，作为有关网络日志保存。（例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商等）；需要您注意，单独的设备信息、日志信息等是无法识别特定
            自然人身份的信息，故单独的设备信息、日志信息非本政策所指“个人信息”。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，
            我们会将该类个人信息做匿名化、去标识化处理；其他信息：为了预防恶意程序及安全运营所必需，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、总体安装使用情况、性能数据、应用来源，并可能使用或整合您的用户信息、
            交易信息、设备信息、有关网络日志信息，进而综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
        </p>
        <p class="content">2.3.11 您在升级我们的移动客户端（“APP”）或者点击我们产品或服务中的第三方广告信息时，可能会需要您开启安装应用的权限，如果您拒绝开启，
            您可能无法完成我们的APP升级或使用第三方的产品或者服务。</p>


        <p class="content">2.3.12 您理解并同意，我们提供的产品/服务可能需要您在您的设备中开启您的位置信息、相机、相册、麦克风、悬浮窗、获取应用账户、拨打电话、接受/读取短信的访 问权限，
            以实现这些权限所涉及信息的收集和使用。我们会在您使用相关服务时弹窗提示您是否要开启相应权限。您可在您的设备设置查看上述权限的状态，并可自 行决定这些权限随时的开启或关闭。请您注意，
            您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您 取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，
            您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用,您可以随时通过您设备的相关功能设置开启/取消该权限。</p>
        <p class="content">
            2.3.13 为保障能实现与安全稳定运行之目的，我们可能会申请或使用操作系统的相关权限；为保障您的知情权，我们通过下列列表将产品可能申请、使用的相关操作系统权限进行展示，您可以根据实际需要对相关权限进行管理；
        </p>
        <p class="content">
            根据产品的升级，申请、使用权限的类型与目的可能会有变动，我们将及时根据这些变动对列表进行调整，以确保您及时获悉权限的申请与使用情况；
        </p>
        <p class="content">
            请您知悉，我们为业务与产品的功能与安全需要，我们可能也会使用第三方SDK，这些第三方也可能会申请或使用相关操作系统权限；
        </p>
        <p class="content">
            操作系统应用权限列表:
        </p>
        <!-- <p class="contentBlack">以下是详细具体相关权限获取使用目的、方式、范围说明（以下权限可以通过您设备的相关功能设置开启/取消该权限）：</p> -->
        <p class="contentBlack">1.网络请求权限 android.permission.INTERNET</p>
        <span class="content">权限功能说明：提供手机网络访问功能</span>
        <span class="content">使用场景与目的：允许App联网访问网络数据</span>
        
        <p class="contentBlack">2.读取手机状态和身份（电话权限、设备权限 ）android.permission.READ_PHONE_STATE</p>
        <span class="content">权限功能说明：提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息</span>
        <span class="content">使用场景与目的：读取设备识别码，识别设备ID，用于完成音视频、信息展示、账号登录、安全保障等主要功能</span>

        <p class="contentBlack">3.手机网络状态权限 android.permission.ACCESS_NETWORK_STATE</p>
        <span class="content">权限功能说明：允许程序访问手机电话卡网络信息</span>
        <span class="content">使用场景与目的：手机流量网络状态（2g/3g/4g/5g）获取，检测网络状态</span>

        <p class="contentBlack">4.wifi状态权限 android.permission.ACCESS_WIFI_STATE</p>
        <span class="content">权限功能说明：监听wifi状态</span>
        <span class="content">使用场景与目的：检测网络状态</span>

        <p class="contentBlack">5.获取wifi名称 android.permission.ACCESS_WIFI_STATE</p>
        <span class="content">权限功能说明：获取当用户连接wifi时的热点名称</span>
        <span class="content">使用场景与目的：用于监测当用户网络不好时，提醒用户可以更换网络达到更好的使用效果</span>

        <p class="contentBlack">6.获取局域网IP地址 android.permission.ACCESS_WIFI_STATE</p>
        <span class="content">权限功能说明：获取用户连接局域网时，完整的ip地址</span>
        <span class="content">使用场景与目的：预防黑产和不法分子的攻击，从而影响正常用户的使用</span>

        <p class="contentBlack">7.读取/写入/删除SD卡中的内容（写入/删除/存储空间/照片权限） android.permission.WRITE_EXTERNAL_STORAGE</p>
        <span class="content">权限功能说明：提供读取、写入外部储存功能</span>
        <span class="content">使用场景与目的：允许App写入/下载/保存/缓存/修改/删除图片、文件、崩溃日志等信息</span>

        <p class="contentBlack">8.拍摄照片和视频 android.permission.CAMERA</p>
        <span class="content">权限功能说明：使用拍摄照片和视频</span>
        <span class="content">使用场景与目的：用于帮助您拍摄发布音视频、进行直播等需要使用该权限的相关功能</span>

        <p class="contentBlack">9.访问精确地理位置信 android.permission.ACCESS_FINE_LOCATION</p>
        <span class="content">权限功能说明：通过全球定位系统（GPS）或网络位置信息（例如基站和WLAN）获取精准地理位置信息</span>
        <span class="content">使用场景与目的：用于完成安全保障服务及基于地理位置的服务（LBS）如：所在城市定位使用相关位置服务等相关功能</span>

        <p class="contentBlack">10.读取SD卡中内容 android.permission.READ_EXTERNAL_STORAGE</p>
        <span class="content">权限功能说明：提供读取外部储存功能</span>
        <span class="content">使用场景与目的：允许App读取图片、文件、崩溃日志等信息</span>

        <p class="contentBlack">11.录音权限 android.permission.RECORD_AUDIO</p>
        <span class="content">权限功能说明：允许App麦克风</span>
        <span class="content">使用场景与目的：拍动态、形象视频</span>

        <p class="contentBlack">12.推送权限 android.permission.RECEIVE_MSG</p>
        <span class="content">权限功能说明：接收推送消息</span>
        <span class="content">使用场景与目的：接收推送消息</span>

        <p class="contentBlack">13.剪切板</p>
        <span class="content">
            <span style="font-weight: bold; color: black">使用目的：</span>
            为了实现分享的功能，我们需要访问您的剪切板，读取其中包含的链接、内容。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用方式：</span>
            当用户同意平台隐私政策进入到登录页面之后，相关的进程即会读取用户剪切板的内容。我们只会记录与我们分享相关的信息，如果无关的信息被读取到，
            我们承诺不会做任何记录和分析。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用范围：</span>
            “com.xsj.crasheye”、“hear.time.reality”、“hear.time.happy”及相关子进程，
        </span>

        <p class="contentBlack">14.获取运行中的进程相关信息</p>
        <span class="content">
            <span style="font-weight: bold; color: black">使用目的：</span>
            为了保障用户正常的应用使用环境，防止被恶意程序或黑产用户影响App 的正常使用。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用方式：</span>
            当用户同意平台隐私政策之后，应用会在适当且不影响用户正常使用的情况下，检测运行中的进程信息。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用范围：</span>
            “com.xsj.crasheye”、“高德地图Android”、“BuglySDK”、及相关子进程。
        </span>

        <p class="contentBlack">15.设备MAC 地址</p>
        <span class="content">
            <span style="font-weight: bold; color: black">使用目的：</span>
            为了在Android Q 以下版本，标识用户来源的唯一性
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用方式：</span>
            当用户同意平台隐私政策之后，应用会根据手机系统环境，获取MAC 地址相关信息。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用范围：</span>
            本应用、及隐私协议中列出的第三方SDK 及相关子进程。
        </span>

        <p class="contentBlack">16.软件安装列表</p>
        <span class="content">
            <span style="font-weight: bold; color: black">使用目的：</span>
            通过获取软件安装列表识别手机上安装的一些其他软件，来维护手机系统环境的安全。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用方式：</span>
            当用户同意平台隐私政策之后，第三方SDK 会根据用户给予的权限，获取软件安装列表相关信息。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用范围：</span>
            该隐私协议中列出的第三方SDK 及相关子进程。
        </span>

        <p class="contentBlack">17.AndroidID</p>
        <span class="content">
            <span style="font-weight: bold; color: black">使用目的：</span>
            用来标识用户在平台的唯一性，防止刷号扰乱平台秩序。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用方式：</span>
            在用户同意平台隐私政策之后，调用相关代码获取AndroidID。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用范围：</span>
            本应用、该隐私协议中列出的第三方SDK 及相关子进程。
        </span>

        <p class="contentBlack">18.传感器数据</p>
        <span class="content">
            <span style="font-weight: bold; color: black">使用目的：</span>
            注册登陆保护、设备风险保护、营销活动反作弊、流量反作弊、支付风险防控等全栈式的账号安全风控服务。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用方式：</span>
            在用户同意平台隐私政策之后，调用相关代码获取传感器相关数据。
        </span>
        <span class="content">
            <span style="font-weight: bold; color: black">使用范围：</span>
            本应用、该隐私协议中列出的数美第三方SDK 及相关子进程。
        </span>












        <p class="contentBlack">
            除提供基础服务所必要的信息外，拒绝提供其他信息将不影响您正常使用本应用的其他功能。
        </p>



        <!-- <p class="contentBlack">获取权限名称：电话 CALL_PHONE</p>
        <span class="content">描述：拨打电话</span>
        <span class="content">对应功能：应用于使用一键登录功能</span>

        <p class="contentBlack">获取权限名称：储存空间 WRITE_EXTERNAL_STORAGE</p>
        <span class="content">描述：修改或删除您sd卡中的内容</span>
        <span class="content">对应功能：应用于版本更新、相册功能、拍照、上传视频</span>

        <p class="contentBlack">获取权限名称：位置信息 ACCESS_FINE_LOCATION</p>
        <span class="content">描述：访问确切位置信息（以gps或网络为依据）</span>
        <span class="content">对应功能：应用于推荐官功能，获取地理位置信息推荐</span>

        <p class="contentBlack">获取权限名称：位置信息 ACCESS_COARSE_LOCATION</p>
        <span class="content">描述：访问大致位置信息（以网络为依据）</span>
        <span class="content">对应功能：应用于推荐官功能，获取地理位置信息推荐</span>

        <p class="contentBlack">获取权限名称：麦克风 RECORD_AUDIO</p>
        <span class="content">描述：录音</span>
        <span class="content">对应功能：应用拍摄个人视频上传功能需要</span>


        <p class="contentBlack">获取权限名称：相机 CAMERA</p>
        <span class="content">描述：拍摄照片和视频</span>
        <span class="content">对应功能：应用于个人相册图片上传需要</span>

        <p class="contentBlack">获取权限名称：储存空间 READ_EXTERNAL_STORAGE</p>
        <span class="content">描述：读取您的sd卡中的内容</span>
        <span class="content">对应功能：应用于版本更新、相册功能、拍照、上传视频</span>

        <p class="contentBlack">获取权限名称：电话 READ_PHONE_STATE</p>
        <span class="content">描述：读取手机状态和身份</span>
        <span class="content">对应功能：应用于使用一键登陆功能</span> -->



        <p class="content">2.3.14 我们向你提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了你的信息，我们会通过页面提示、交互流程、网站公告等方式另行向你说明信息收集的内容、范围和目的，
            以征得你的同意。</p>
        <span class="content">另外，根据相关法律法规及国家标准，在以下情况下，我们无需取得您的授权同意即可收集和使用您的个人信息：</span>
        <span class="content">1) 与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公众知情等重大公共利益直接相关的；</span>
        <span class="content">2) 与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
        <span class="content">3) 出于维护你或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</span>
        <span class="content">4) 所收集的个人信息是你自行向社会公众公开的；</span>
        <span class="content">5) 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
        <span class="content">6) 根据你要求签订和履行合同所必需的；</span>
        <span class="content">7) 用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
        <span class="content">8) 为开展合法的新闻报道所必需的；</span>
        <span class="content">9) 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
        <span class="content">10) 法律法规规定的其他情形。</span>


        <p class="contentBlack">三、我们如何使用Cookie和同类技术</p>
        <p class="content">3.1 Cookie</p>
        <p class="content">为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、
            站点名称以及一些号码和字符。借助于 Cookie，网站能够存储您的偏好等数据。</p>
        <p class="content">3.2网站信标和像素标签</p>
        <p class="content">除 Cookie 外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，
            帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子 邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，
            则可以随时从我们的寄信名单中退订。</p>
        <p class="content">3.3 SDK技术</p>
        <p class="content">SDK技术由与我们合作的第三方机构提供，我们仅能知悉其要求获得授权的权限。第三方机构将会需要收集您的信息，我们无法获取您的信息，除非第三方机构明确向我们披露的要收集的敏感信息。</p>
        <p class="content">在为安卓系统的用户提供服务时，我们将使用下列SDK技术，所需要的功能和第三方要收集的用户信息为：</p>


        

        <p class="contentBlack">第三方SDK名称：“友盟”SDK</p>
        <span class="content">用途与目的：统计线上crash、anr异常，进行数据统计</span>
        <span class="content">调用权限和获取方式：调用权限和获取方式如下：</span>
        <span class="content">权限：ACCESS_NETWORK_STATE，用途：检测联网方式，在网络异常状态下避免数据发送，节省流量和电量。</span>
        <span class="content">权限：READ_PHONE_STATE，用途：获取用户设备的IMEI，通过IMEI对用户进行唯一标识，以便提供统计分析服务。</span>
        <span class="content">权限：ACCESS_WIFI_STATE，用途：获取WIFI mac地址，在平板设备或电视盒子上，无法通过IMEI标识设备，我们会将WIFI mac地址作为用户的唯一标识，以便正常提供统计分析服务。</span>
        <span class="content">权限：INTERNET，用途：允许应用程序联网和发送统计数据的权限，以便提供统计分析服务。</span>
        <span class="content">权限：ACCESS_FINE_LOCATION（可选），用途：通过获取位置信息，为开发者提供反作弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</span>
        <span class="content">权限：ACCESS_COARSE_LOCATION（可选），用途：通过获取位置信息，为开发者提供反作弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确。</span>
        <!-- <span class="content">权限：，用途：</span> -->
        <span class="content">收集的个人信息类型：设备信息（IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息），通过采集唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID/IP地址/SIM卡 IMSI 信息）
            对用户进行唯一标识，以便进行诸如用户新增数据统计。在特殊情况下（如用户使用平板设备或电视盒子时），无法通过唯一设备识别码标识设备，我们会将设备Mac地址作为用户的唯一标识，以便正常提供统计分析服务。
            统计分析服务具备基础的反作弊功能，通过获取用户位置信息及IP地址，剔除作弊设备，同时矫正用户的地域分布数据，提高报表数据的准确性。</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></span>


        <p class="contentBlack">第三方SDK名称：“闪验SDK”的SDK</p>
        <span class="content">用途与目的：APP免密登录，一键注册登陆；获取MAC地址设备信息用于独立区分设备信息。</span>
        <span class="content">调用权限和获取方式：</span>
        <span class="content">权限：INTERNET，权限说明：允许应用程序联网，用途：用于访问网关和认证服务器</span>
        <span class="content">权限：ACCESS_WIFI_STATE，权限说明：允许访问WiFi网络状态信息，用途：允许程序访问WiFi网络状态信息</span>
        <span class="content">权限：ACCESS_NETWORK_STATE，权限说明：允许访问网络状态，用途：区分移动网络或WiFi网络</span>
        <span class="content">权限：CHANGE_NETWORK_STATE，权限说明：允许改变网络连接状态，用途：设备在WiFi跟数据双开时，强行切换使用数据网络</span>
        <span class="content">权限：CHANGE_WIFI_STATE，权限说明：允许改变WiFi网络连接状态，用途：设备在WiFi跟数据双开时，强行切换使用</span>
        <span class="content">权限：READ_PHONE_STATE，权限说明：允许读取手机状态，用途：（可选）获取IMSI用于判断双卡和换卡</span>
        <span class="content">权限：WRITE_SETTINGS，权限说明：允许读写系统设置项，用途：电信SDK在6.0系统以下进行数据切换用到的权限，添加后可增加电信在WiFi+4G下网络环境下的取号成功率。6.0系统以上可去除</span>
        <span class="content">权限：GET_TASKS，权限说明：允许应用程序访问TASK，用途：电信SDK在6.0系统以下进行数据切换用到的权限，添加后可增加电信在WiFi+4G下网络环境下的取号成功率。6.0系统以上可去除</span>

        <span class="content">收集的个人信息类型：为了实现网关取号技术，闪验SDK需要获取IP地址、网卡（MAC)地址、国际移动设备识别码（IMEI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、
            系统版本、网络环境、网关取号报错日志数据以提供统计分析服务能力，并可提供反欺诈功能。</span>
        <span class="content">提供SDK的公司官网链接：<a href="http://shanyan.253.com/">http://shanyan.253.com/</a></span>

        <!-- <p class="contentBlack">第三方SDK名称：“支付宝实名认证”的SDK</p>
        <span class="content">用途与目的：对用户进行人脸实名认证</span>
        <span class="content">调用权限和获取方式：存储权限、相机权限</span>
        <span class="content">收集的个人信息类型：个人身份信息、面部识别特征</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://cn.aliyun.com/product/cloudauth">https://cn.aliyun.com/product/cloudauth</a></span> -->

        <p class="contentBlack">第三方SDK名称：“微信支付”的SDK</p>
        <span class="content">用途与目的：帮助用户在应用内使用微信支付</span>
        <span class="content">调用权限和获取方式：读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://pay.weixin.qq.com/">https://pay.weixin.qq.com/</a></span>

        <p class="contentBlack">第三方SDK名称：Alipay（支付宝） SDK</p>
        <span class="content">用途与目的：帮助用户在应用内使用支付宝支付</span>
        <span class="content">调用权限和获取方式：读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://docs.open.alipay.com/">https://docs.open.alipay.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“FaceUnity”相芯科技的SDK</p>
        <span class="content">用途与目的：提供用户在应用内对头像进行美颜的功能</span>
        <span class="content">调用权限和获取方式：相机权限、存储权限</span>
        <span class="content">收集的个人信息类型：无</span>
        <span class="content">提供SDK的公司官网链接：<a href="http://www.faceunity.com/">http://www.faceunity.com/</a></span>

        <p class="contentBlack">第三方SDK名称：“OPPO push”SDK</p>
        <span class="content">用途与目的：向用户推送消息，具体而言，我们可能会将您的个人信息用于下列目的</span>
        <span class="content">1、将开发者提供的应用服务中与您相关的信息（如私信、账户变化、关注动态及营销信息）及时推送到您的设备终端。</span>
        <span class="content">2、提供、处理、维护、改善、开发我们的产品和/或提供给您的服务，包括按照您的系统、设备、应用信息推送符合技术标准的消息，记录消息发送结果返回给开发者，提供折叠不重要通知功能。</span>
        <span class="content">3、分析和开发与我们产品或服务的使用相关的统计信息，以更好地改进我们的产品或服务。</span>
        <span class="content">4、优化产品的性能，如折叠消息算法的优化。</span>
        <span class="content">5、储存并维护与您相关的信息，用于我们运营业务或履行法律义务。</span>
        <span class="content">6、进行与市场营销有关的活动，例如提供并更新市场营销或推广内容。如果您不再希望收到某些类型的推广内容，除非适用法律另有规定。</span>
        <span class="content">7、您可以按照消息中提供的方法（例如消息底部的退订链接）选择退订。</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备相关信息（如IMEI号，Serial Number，IMSI，User ID，Android ID，Google Advertising ID, 手机Region设置，设备型号，手机电量，手机操作系统版本及语言）、
            使用推送服务的应用信息（如APP包名及版本号，运行状态）、推送SDK版本号、网络相关信息（如IP或域名连接结果，当前网络类型）、消息发送结果，通知栏状态（如通知栏权限、用户点击行为），锁屏状态（如是否锁屏，是否允许锁屏通知）</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.oppomobile.com/wiki/doctid=10196">https://open.oppomobile.com/wiki/doctid=10196</a></span>

        <p class="contentBlack">第三方SDK名称：“VIVO push”SDK</p>
        <span class="content">用途与目的：向VIVO手机用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://dev.vivo.com.cn/home">https://dev.vivo.com.cn/home</a></span>

        <p class="contentBlack">第三方SDK名称：“小米push”SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://dev.mi.com/console/appservice/push.html">https://dev.mi.com/console/appservice/push.html</a></span>

        <p class="contentBlack">第三方SDK名称：“华为push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：AAID（应用匿名标识）、应用Token、Topic订阅关系，如果您选择了数据处理位置，则按照您选择的数据处理位置进行数据处理；否则以上信息将不被进行处理。
            消息下发记录、Token申请记录、显示/点击/关闭打点上报记录，需要您开启华为分析能力并且选择数据处理位置，才会进行数据处理，否则不进行数据处理。
            缓存消息内容，根据客户端所在的大区（详情请参见数据处理位置的分布）进行数据处理。
            如果您的应用推送消息时，启用了基于华为帐号的消息校验功能，我们将在该场景下收集手机用户的标识符HMS Core openId，HMS Core openId将进行不可逆加密仅保存在设备端侧。
            您发送的消息内容将被保存到最终用户设备端侧。</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://developer.huawei.com/consumer/cn/service/hms/pushservice.html">https://developer.huawei.com/</a></span>

        <!-- <p class="contentBlack">第三方SDK名称：“阿里push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.1688.com/">https://open.1688.com/</a></span> -->

        <!-- <p class="contentBlack">第三方SDK名称：“魅族push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="http://open.flyme.cn/">http://open.flyme.cn/</a></span> -->

        <!-- <p class="contentBlack">第三方SDK名称：“阿里push”的SDK</p>
        <span class="content">用途与目的：向用户推送消息</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.1688.com/">https://open.1688.com/</a></span> -->

        <p class="contentBlack">第三方SDK名称：“腾讯云-即时通讯IM”的SDK</p>
        <span class="content">用途与目的：给应用内的用户提供IM聊天的功能</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态、呼吸灯权限、振动器权限、相机权限、录音权限</span>
        <span class="content">收集的个人信息类型：终端设备和 SDK 日志信息数据，内容包括：操作系统版本，应⽤包名，设备id，屏幕尺寸，app安装渠道，操作系统的名称版本号，时区，语言，网络类型，
            app版本号，手机是否越狱，idfv，融云sdk版本号，用户应用的appkey，用户token，用户的手机制造厂商，运营商mno，接口调用的错误码，链接失败的错误码和用户信息，用户发送消息的内容</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://cloud.tencent.com/product/im">https://cloud.tencent.com/product/im/</a></span>

        <!-- <p class="contentBlack">第三方SDK名称：“百度文字识别”的SDK</p>
        <span class="content">用途与目的：给应用内用户提供图片文字识别功能</span>
        <span class="content">调用权限和获取方式：存储权限、读取网络状态、相机权限</span>
        <span class="content">收集的个人信息类型：网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://ai.baidu.com/">https://ai.baidu.com/</a></span> -->

        <p class="contentBlack">第三方SDK名称：“腾讯TRTC 音视频”SDK</p>
        <span class="content">用途与目的：给应用内用户提供音视频通话服务</span>
        <span class="content">调用权限和获取方式：存储权限、读取网络状态、相机权限</span>
        <span class="content">收集的个人信息类型：设备标识信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://cloud.tencent.com/product/trtc">https://cloud.tencent.com/product/trtc</a></span>


        <p class="contentBlack">第三方SDK名称：“腾讯云Bugly”SDK</p>
        <span class="content">用途与目的：用户使用应用时的异常统计和运营数据统计</span>
        <span class="content">调用权限和获取方式：设备信息（手机型号、手机品牌、Android系统版本）、设备标识信息（IMEI、IDFA、Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）</span>
        <span class="content">收集的个人信息类型：设备信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://bugly.qq.com/">https://bugly.qq.com/</a></span>


        <p class="contentBlack">第三方SDK名称：“数美设备风险”SDK</p>
        <span class="content">用途与目的：用于整个平台的内容风控系统，保护用户的信息和设备安全。</span>
        <span class="content">调用权限和获取方式：存储权限、读取设备信息、读取网络状态、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：获取AndroidID、IMEI、IDFV、IDFA、OAID、MAC地址等设备标识信息、获取网络基站信息、读取、保存设备信息以及记录日志、获取网络接入形式信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://www.ishumei.com/legal/cn/privacy.html">https://www.ishumei.com/legal/cn/privacy.html</a></span>


        <p class="contentBlack">第三方SDK名称：“高德地图”SDK</p>
        <span class="content">用途与目的：为了给平台内用户提供获取模糊/精准的定位服务，并且提供与位置相关的平台内服务</span>
        <span class="content">调用权限和获取方式：位置信息、设备信息、设备标识信息（IMEI、IDFA、Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）</span>
        <span class="content">收集的个人信息类型：设备信息、网络信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://lbs.amap.com/pages/privacy">https://lbs.amap.com/pages/privacy</a></span>

        <p class="contentBlack">第三方SDK名称：“巨量广告转化”SDK</p>
        <span class="content">用途与目的：为了针对产品的广告投放进行归因，降低投放成本</span>
        <span class="content">调用权限和获取方式：设备信息、设备标识信息（IMEI、IDFA、Android ID、MEID、MAC地址、OAID、IMSI、ICCID、硬件序列号）</span>
        <span class="content">收集的个人信息类型：设备信息</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://www.oceanengine.com/">https://www.oceanengine.com/</a></span>


        <!-- <p class="contentBlack">第三方SDK名称：“微博”SDK</p>
        <span class="content">用途与目的：用于实现微博分享功能，将用户选择的图片或视频分享至微博</span>
        <span class="content">调用权限和获取方式：读取设备信息、设备MAC地址、电信运营商等软硬件特征信息、读取网络状态、相机权限、读取WIFI状态</span>
        <span class="content">收集的个人信息类型：获取IMEI等设备标识信息、获取网络基站信息、读取、保存设备信息以及记录日志</span>
        <span class="content">提供SDK的公司官网链接：<a href="https://open.weibo.com/wiki/index.php?title=Sdk/privacy&printable=yes">https://open.weibo.com/wiki/index.php?title=Sdk/privacy&printable=yes</a></span> -->


        <p class="contentBlack">同时，我们使用了其他不需要获取权限，也不需要获取用户信息的SDK，包括：</p>
        <span class="content">1) AndPermission SDK（用于询问权限的框架工具，本身不需权限）；</span>
        <span class="content">2) BlankjUtilCode SDK（用于提高开发效率）；</span>
        <span class="content">3) 阿里云播放 SDK（用于播放视频）；</span>
        <span class="content">4) 移动安全联盟 SDK(用于规范标识移动设备）</span>
        <!-- <span class="content">5）北京提子科技SDK（即135编辑器，用于应用内发布h5文章时，对文章内容进行排版处理并存放文章内所展示的图片，排版处理完成之后，用于应用内展示相关文章内容）；</span> -->
        <!-- <span class="content">5）“React Native”的SDK（com.facebook 开头的进程），用于将编写的js 代码编程器成原生可识别的java 代码和Objective-C 代码，进行跨平台开发。</span> -->




        <p class="content">3.4保障产品与服务的安全、高效运转</p>
        <p class="content">如果您拒绝我们使用Cookie及同类技术收集和使用您的相关信息，您可在浏览器具备该功能的前提下，通过您的浏览器的设置以管理、
            （部分/全部）拒绝 Cookie与/或同类技术；或删除已经储存在您的计算机、移动设备或其他装置内的Cookie与/或同类技术，从而实现我们无法全部或部分追踪您的个人 信息。您如需详细了解如何更改浏览器设置，
            请具体查看您使用的浏览器的相关设置页面。您理解并知悉：我们的某些产品/服务只能通过使用Cookie或同类 技术才可得到实现，如您拒绝使用或删除的，您可能将无法正常使用我们的相关产品与/或服务或无法通过我们
            的产品与/或服务获得最佳的服务体验，同时也可能 会对您的信息保护和账号安全性造成一定的影响。</p>
        
        <p class="contentBlack">四、我们如何共享、转让、公开披露您的个人信息</p>
        <p class="content">4.1 共享</p>
        <p class="content">4.1.1 您的个人信息可能会在我们的关联公司之间共享。我们只会共享必要的个人信息（如为便于您使用本平台账号使用关联公司的其他产品或服务，识别账号异常或保护本平台关联公司或其他用户或公众的人身财产
            安全免遭侵害，我们会在关联公司内共享您必要的账户信息）且会受本隐私群政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</p>
        <p class="content">4.1.2 为了向您提供更完善、优质的产品和服务，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确
            的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。同时，我们会与合作伙伴签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密
            和安全措施来处理您的个人信息。我们的合作伙伴无权 将共享的个人信息用于任何其他用途。如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方 服务。</p>
        <p class="content">4.2 转让</p>
        <p class="content">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
        <p class="content">4.2.1 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
        <p class="content">4.2.2 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
        <p class="content">4.3 公开披露</p>
        <p class="content">我们仅会在以下情况下，公开披露您的个人信息：</p>
        <span class="content">1）获得您明确同意后；</span>
        <span class="content">2）基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span>
        <span class="content">3）因需要对违规账号、欺诈行为等进行处罚公告的。特别提示：对于公开披露的您的个人信息，我们会在收到公开披露申请后第一时间且审慎审查其正当性、合理性、合法性，
            并在公开披露时和公开披露后采取最严格个人信息安全保护措施和手段对其进行保护。</span>

        <p class="content">4.4 共享、转让、公开披露您的个人信息的例外</p>
        <p class="content">请您知悉，另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得个人信息主体的授权同意：</p>
        <span class="content">1） 与国家安全、国防安全直接相关的；</span>
        <span class="content">2） 与公共安全、公共卫生、重大公共利益直接相关的；</span>
        <span class="content">3） 与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
        <span class="content">4） 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的</span>
        <span class="content">5） 个人信息主体自行向社会公众公开的个人信息；</span>
        <span class="content">6） 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道</span>
        <p class="content">根据法律规定， 若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。</p>

         <p class="contentBlack">五、我们如何保护您的个人信息</p>
         <p class="content">5.1 我们使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改，防止数据发生损坏或丢失。我们将在合理的 安全水平内使用各种安全保护措施以保障信息的安全。
             例如，我们会使用加密技术（例如，SSL）、匿名化处理等手段来保护你的个人信息。我们已建立访问控制 机制，确保只有授权人员才可以访问个人信息；我们不时的举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
         <p class="content">5.2 我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力，以防止你的个人信息泄露。例如，我们为了安全传输会在你设备本地完成部分信息加密的工作；为了预防病毒、木马程序或其他恶意程序、
             网站会了解你设备安装的应用信息或正在运行的进程信息</p>
         <p class="content">5.3 我们建立专门的管理制度、流程和组织以保障信息的安全。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审计。</p>
         <p class="content">5.4 若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知你。</p>
         <p class="content">5.5 我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
         <p class="content">5.6 互联网并非绝对安全的环境，因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码等个人信息透露给他人。
             如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络本平台客服，以便我们根据您的申请采取相应措施。</p>
         <p class="content">5.7 互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您 告知：安全事件的基本情况和可能的影响、
             我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以 邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
             同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>

         <p class="contentBlack">六、您的权利</p>    
         <p class="content">我们理解您对个人信息的关注，为了你可以更加便捷地访问、更正、补充、删除您的个人信息，同时保障你撤回对个人信息使用的同意及注销账号的权利，我们在产品设计中为你提供了相应的操作设置，
             你可以参考下面的指引进行操作。此外，我们还设置了投诉举报渠道，你的意见将会得到及时的处理。</p>
         <p class="content">6.1 访问、更正和补充您的个人信息</p>
         <p class="content">访问、更正和补充头像、我的相册、我的动态、个人证件信息、基本条件、择偶条件等基本信息：</p>
         <p class="content">登录账号后，点击“我的”模块后点击头像，进行信息访问、更正和补充。</p>
         <p class="content">6.2 访问、更正手机号、登录密码等账户信息</p>
         <p class="content">登录账号后，点击“我的”-点击“系统设置”-点击“账户安全”，进行信息访问、查询。</p>
         <p class="content">如果您无法通过上述路径访问查询，您可以通过应用内“在线客服”与我们取得联系。</p>
         <p class="content">对于您在行使上述权利过程中遇到的困难，或者其他可能目前无法向您提供在线自行更正/修改服务的，经过对您身份的验证，
            且更正/修改不影响信息的客观性和准确性的情况下，您有权对错误或不完整的信息作出更正或修改， 或在特定情况下，尤其是数据错误时，
            通过我们公布的反馈与报错等措施将您的更正/修改申请提交给我们，要求我们更正或修改您的数据，但法律法规另有规定的除外。
            但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。</p>
         <p class="content">6.3 注销并删除您的个人信息</p>
         <p class="content">登录账号后，点击“我的”-“系统设置”-“账户安全”-“注销账号”，注销并删除个人信息。</p>
         <p class="content">在以下情形中，您可以向我们提出删除个人信息的请求：</p>
         <span class="content">1）如果我们处理个人信息的行为违反法律法规；</span>
         <span class="content">2）如果我们收集、使用您的个人信息，却未征得您的明确同意；</span>
         <span class="content">3）如果我们处理个人信息的行为严重违反了与您的约定；</span>
         <span class="content">4）如果您不再使用我们的产品或服务，或您主动注销了账号；</span>
         <span class="content">5）如果我们永久不再为您提供产品或服务。</span>
         <p class="content">若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</p>
         <p class="content">当您或我们协助您从我们的服务中删除信息后，依据相关法律法规的规定，我们可能不会立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。</p>

         <p class="content">6.4 访问隐私政策</p>
         <p class="content">您可以在注册页面，或者登录账号后，点击“我的”-点击“系统设置”-点击“隐私政策”。</p>

         <p class="content">6.5 撤回您对个人信息的同意</p>
         <p class="content">我们提供的产品和服务的部分功能需要获得您使用设备的相关权限（包括：位置、相册、相机、麦克风等，具体以产品实际获取的功能为准）。您可以在授权后随时撤回（或停止）对该权限的继续授权。您需理解，
             当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能和/或服务。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理</p>
         <p class="content">6.6 响应您的上述请求</p>
         <p class="content">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。</p>
         <p class="content">我们将在14个工作日内做出答复。如您不满意，还可以通过本平台客 服发起投诉。 对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、
             需要过多技术手段（例如， 需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</p>
         <p class="content">在以下情形中，按照法律法规要求，我们将无法响应您的请求：</p>
         <span class="content">1）与国家安全、国防安全有关的；</span>
         <span class="content">2）与公共安全、公共卫生、重大公共利益有关的；</span>
         <span class="content">3）与犯罪侦查、起诉、审判和执行判决等有关的；</span>
         <span class="content">4）有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span>
         <span class="content">5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；。</span>
         <span class="content">6）涉及商业秘密的。</span>


         <p class="contentBlack">七、我们如何存储您的个人信息</p>         
         <p class="content">7.1信息存储的地点</p>
         <p class="content">我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
         <p class="content">7.2信息存储的期限</p>
         <p class="content">一般而言，我们在您使用服务时获取到您个人信息内会进行存储，并在您注销本平台账户后合理期限内删除或进行匿名化处理。</p>
         <p class="content">当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知您，并在合理的期限内删除您的个人信息或进行匿名化处理。</p>

         
         <p class="contentBlack">八、使用须知</p>
         <!-- <p class="contentBlack">只有年满18周岁，具有完全民事行为能力的单身人士才可以注册。本平台不会向未成年人推销自己，或者未经父母同意而有意收集其未成年子女的个人信息。</p> -->
         <p class="content">8.1平台通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及平台规定的情况下，方有权使用{{ appName }}App、网站、微信公众号等平台的相关服务。</p>
         <p class="content">8.2用户必须自行准备如下设备和承担如下开支：</p>
         <span class="content">1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；</span>
         <span class="content">2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</span>

         <p class="content">8.3用户应自行诚信向平台提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且平台保留终止用户使用平台各项服务的权利。</p>
         <p class="content">8.4用户注册成功后，将产生用户名和密码等账户信息，您可以根据平台规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知平台并向公安机关报案。</p>
         <p class="content">8.5用户同意，平台拥有通过邮件、短信电话等形式，向在平台注册用户、收促销活动等告知信息的权利。</p>
         <p class="content">8.6用户不得将在平台注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。</p>
         <p class="content">8.7平台网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解。</p>

         <p class="content">
            8.8您知晓并同意，公司有权基于消费安全等方面的考虑不时设定或修改涉及消费的相关事项，包括但不限于消费限额、消费次数等。
            您了解并确认知晓公司的前述设定或修改可能对您的消费产生一定的不便。
        </p>
        <p class="content">
            8.9公司禁止未成年人使用本平台服务。监护人因未尽监护责任，导致未成年使用充值服务，视为监护人作出的行为，公司不予退款。
        </p>
        <p class="content">
            8.10因您自身原因导致公司无法提供充值服务或提现失败或购买服务时发生任何错误而产生的任何损失或责任，
            由您自行负责，公司不承担责任，包括但不限于：
        </p>
        <span class="content">
            1).因您的{{ appName }}帐号丢失、被封禁或冻结；
        </span>
        <span class="content">
            2).因您将密码告知他人导致的财产损失；
        </span>
        <span class="content">
            3).因您绑定的第三方支付机构帐户的原因导致的任何损失或责任；
        </span>
        <span class="content">
            4).其他您故意或者重大过失导致的或者违反法律法规导致的财产损失。
        </span>
        <span class="content">
            5）.因您违规帐户被禁用，帐户中虚拟货币将被冻结扣除清零，不得退回或提现。
        </span>
        <!-- <p class="content"></p> -->


         <p class="content">
            8.11用户一旦接受本协议，即表明该用户主动将其在任何时间段在平台发表的任何形式的信息内容（包括但不限于评价、咨询、各类话题文章等信息内容）
            的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、
            摄制权、改编权、 翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给平台所有，
            用户同意平台有权就任何主体侵权而单独提起诉讼。
        </p>
         <p class="content">
            8.12本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权
            等权利转让书面协议，其效力及于用户在平台上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
         </p>
         <p class="content">
            8.13用户同意并已充分了解本协议的条款，承诺不将已发表于平台的信息，以任何形式发布或授权其它主体以任何方式使用
            （包括但不限于在各类网站、媒体上使用）。
         </p>

         <p class="content">
            8.14平台是平台的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及平台的内容进行修改，
            并在平台张贴，无须另行通知用户。在法律允许的最大限度范围内，平台对本协议及平台内容拥有解释权。
        </p>
         <!-- <p class="content">8.1信息存储的地点</p> -->


         <p class="contentBlack">九、联系我们</p>
         <p class="content">9.1 如您对《个人信息保护政策》的内容或使用我们的服务时遇到的与隐私保护相关的事宜有任何疑问或进行咨询或投诉时，您均可以通过如下任一方式与我们取得联系：</p>
         <span class="content">1）您可找到我们平台上产品功能页面中在线客服与我们联系；</span>
         <span class="content">2）您可以拨打客服电话{{ companyPhone }}与我们联系；</span>
         <span class="content">3）您可以发送邮件至：{{ companyMail }}</span>
         <p class="content">9.2 我们会在收到您的意见及建议后，并在验证您的用户身份后的11个工作日内尽快向您回复。此外，您理解并知悉，在与个人信息有关的如下情形下，我们将无法回复您的请求：</p>
         <span class="content">1）与国家安全、国防安全有关的；</span>
         <span class="content">2）与公共安全、公共卫生、重大公共利益有关的；</span>
         <span class="content">3）与犯罪侦查、起诉和审判等有关的；</span>
         <span class="content">4）有充分证据表明您存在主观恶意或滥用权利的；</span>
         <span class="content">5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span>
         <span class="content">6）涉及商业秘密的；</span>
         <span class="content">7）法律法规等规定的其他情形。</span>

         <p class="content">9.3 关于我们</p>
         <span class="content">1）公司名称：{{ companyName }}</span>
         <span class="content">2）注册地址：{{ companyAddress }}}</span>
         <span class="content">3）常用办公地址：{{ companyAddress }}</span>
         <span class="content">4）信息保护负责人联系电话：{{ companyPhone }}</span>

         <p class="contentBlack">十、本政策如何更新</p>
         <p class="content">10.1 为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新《个人信息保护政策》的条款，该等更新构成《个人信息保护政策》的一部分。未经您明确同意，
             我们不会削减您按照本政策所应享有的权利。如该等更新造成您在本《个人信息保护政策》下权利的实质减少或重大变更，我们将在本政策生效前通过在显著位置提示或向您发送推送消息或以其他方式通知您，
             若您继续使用我们的服务，即表示您充分阅读、理解并同意受经修订的《个人信息保护政策》的约束</p>
         <p class="content">10.2 重大变更包括但不限于：</p>
         <span class="content">1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
         <span class="content">2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span>
         <span class="content">3）个人信息共享、转让或公开披露的主要对象发生变化；</span>
         <span class="content">4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
         <span class="content">5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；</span>
         <span class="content">6）个人信息安全影响评估报告表明存在高风险时。</span>

         <p class="contentBlack">十一、争议解决</p>
         <p class="content">11.1 本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，您同意向当地人民法院提起诉讼来寻求解决方案。</p>
         <p class="content">11.2 如果您认为我们处理个人信息的行为损害了您的合法权益，您也可以选择向有关政府部门进行反映。</p>

         <p class="content">注：《个人信息保护政策》版本更新日期为2023年07月04日，将于2023年07月04日正式生效。</p>



    </div>
</template>

<script>
export default {
    data() {
        return {
            appName: '',
            companyName: '',

            companyMail: '',
            companyPhone: '',
            companyAddress: ''
        }
    },

    created() {
        // document.title = '隐私协议';
        // const url = window.location.href;
        // const paramsStr = url.split('?')[1];
        // const paramsArr = paramsStr.split('&');
        // paramsArr.forEach((item) => {
        //     const t = item.split('=');
        //     if (t[0] == 'companyName') this.companyName = decodeURI(t[1]);
        //     if (t[0] == 'appName') this.appName = decodeURI(t[1]);
        //     if (t[0] == 'companyPhone') this.companyPhone = decodeURI(t[1]);
        //     if (t[0] == 'companyMail') this.companyMail = decodeURI(t[1]);
        // })

        this.checkURLParams();
    },

    methods: {
         checkURLParams() {
            // const url = window.location.href;
            // const z = url.split('?');
            // let p = {};
            // try {
            //     const k = z[1].split('&');
            //     k.forEach(item => {
            //         const m = item.split('=');
            //         p[m[0]] = m[1];
            //     })
            //     this.id = p.id;
            //     this.gender = p.gender;
            //     this.token = p.token;
            //     this.checkName(p.edition);
            // } catch(e) {}
            this.checkName();
        },

        checkName(edition) {
            // if (this.appName == '聊伴交友' || this.appName == '昊韵聊伴' || this.appName == "寻缘") {
            //     if (this.companyName == '广州凯帽网络科技有限公司') {
            //         this.companyAddress = '广州市天河区瑞华一街2号';
            //         this.companyPhone = '18049739458';
            //         this.companyMail = 'lnmimicompany@163.com';
            //     } else if (this.companyName = "大连密密网络科技有限公司") {
            //         this.companyAddress = '辽宁省大连保税区自贸大厦813室';
            //         this.companyPhone = '13279457554';
            //         this.companyMail = 'lnmimicompany@163.cn';
            //     } else {
            //         this.companyName = '昊韵晟世（大连）网络科技有限公司';
            //         this.companyAddress = '辽宁省大连市甘井子区凌水镇七贤岭汇贤街17#202室';
            //         this.companyPhone = '18049739458';
            //         this.companyMail = 'haoyunshengshi@163.com';
            //     }
            // } else if (this.appName == '寻Ta交友' || this.appName == '甜缘寻Ta' || this.appName == '觅趣') {
            //     this.companyName = '大连密密网络科技有限公司';
            //     this.companyAddress = '辽宁省大连保税区自贸大厦813室';
            //     this.companyPhone = '13279457554';
            //     this.companyMail = 'lnmimicompany@163.cn';
            // } else {
            //     this.appName = '#本应用#';
            //     this.companyName = '#本公司#';
            //     this.companyAddress = '#无名街道#';
            //     this.companyPhone = '138****2193';
            //     this.companyMail = 'support@**.cn';
            // }
            
            this.appName = '觅趣';
            this.companyName = '长沙珈颜网络科技有限公司';
            this.companyAddress = '长沙市雨花区高桥街道人民东路58号新三诚大厦2101房B区588号';
            this.companyPhone = '15799938769';
            this.companyMail = 'jiayancompany@163.cn';
        }
    }
}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    background-color: #FFF;
}

.content {
    font-size: 12px;
    color: #666;
}
.contentBlack {
    font-size: 14px;
    color: black;
    font-weight: 700;
}
</style>